<template>
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C5.55229 0 6 0.447715 6 1V4.00003H9C9.55228 4.00003 10 4.44775 10 5.00003C10 5.55232 9.55229 6.00003 9 6.00003H6L6 9C6 9.55229 5.55228 10 5 10C4.44771 10 4 9.55228 4 9V6.00003H1C0.447715 6.00003 7.94729e-08 5.55232 0 5.00003C-7.94729e-08 4.44775 0.447715 4.00003 1 4.00003H4L4 1C4 0.447715 4.44772 0 5 0Z"/>
  </svg>
</template>
